import React, { useState } from "react";
import { Mail, Send, CheckCircle2, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import MarketingLayout from "@/components/MarketingLayout";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return toast.error("Please fill in your name, email and message");
    setBusy(true);
    try { await api.post("/support/contact", { name: form.name, email: form.email, subject: form.subject, message: form.message }); setSent(true); }
    catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };

  return (
    <MarketingLayout>
      <div className="fade-up" data-testid="contact-page" style={{ maxWidth: 620, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <span style={{ width: 52, height: 52, borderRadius: 14, background: "var(--brand)", color: "#fff", display: "inline-grid", placeItems: "center" }}><MessageSquare size={24} /></span>
          <h1 style={{ fontSize: 30, fontWeight: 800, marginTop: 14 }}>Get in touch</h1>
          <p className="ss-muted" style={{ marginTop: 8, fontSize: 15 }}>
            Buyers, sellers and donors — we'd love to hear from you. Send us a message and we'll reply by email.
          </p>
        </div>

        <div className="ss-card" style={{ padding: 20, marginBottom: 16, display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }} data-testid="contact-email-card">
          <span style={{ width: 46, height: 46, borderRadius: 12, background: "var(--brand)", color: "#fff", display: "grid", placeItems: "center", flexShrink: 0 }}><Mail size={22} /></span>
          <div style={{ flex: 1, minWidth: 180 }}>
            <div className="ss-muted" style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Email us directly</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text)" }} data-testid="contact-email-label">Tap "Open email" to reach our team</div>
          </div>
          <a className="ss-btn ss-btn-ghost ss-btn-sm" href="mailto:jafar@contract2cashnow.com" data-testid="contact-mailto">Open email</a>
        </div>

        {sent ? (
          <div className="ss-card" style={{ padding: 34, textAlign: "center" }} data-testid="contact-sent">
            <CheckCircle2 size={40} style={{ color: "var(--brand)" }} />
            <h2 style={{ fontSize: 20, marginTop: 10 }}>Message sent!</h2>
            <p className="ss-muted" style={{ marginTop: 6 }}>Thanks {form.name.split(" ")[0]} — we've received your message and will get back to you soon.</p>
          </div>
        ) : (
          <form className="ss-card" style={{ padding: 24 }} onSubmit={submit}>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <div style={{ flex: 1, minWidth: 180 }}>
                <label className="ss-label">Your name</label>
                <div className="ss-field" style={{ height: 44 }}><input placeholder="Full name" value={form.name} onChange={set("name")} data-testid="contact-name" /></div>
              </div>
              <div style={{ flex: 1, minWidth: 180 }}>
                <label className="ss-label">Email</label>
                <div className="ss-field" style={{ height: 44 }}><Mail size={16} className="ss-muted" /><input type="email" placeholder="you@example.com" value={form.email} onChange={set("email")} data-testid="contact-email" /></div>
              </div>
            </div>
            <label className="ss-label" style={{ marginTop: 14 }}>Subject</label>
            <div className="ss-field" style={{ height: 44 }}><input placeholder="How can we help?" value={form.subject} onChange={set("subject")} data-testid="contact-subject" /></div>
            <label className="ss-label" style={{ marginTop: 14 }}>Message</label>
            <textarea placeholder="Write your message…" value={form.message} onChange={set("message")} data-testid="contact-message"
              style={{ width: "100%", minHeight: 130, resize: "vertical", padding: "10px 12px", borderRadius: 12, border: "1px solid var(--line)", background: "var(--surface-2)", color: "var(--text)", fontSize: 14, fontFamily: "inherit" }} />
            <button className="ss-btn ss-btn-primary ss-btn-block" style={{ marginTop: 18 }} disabled={busy} data-testid="contact-submit">
              <Send size={16} /> {busy ? "Sending…" : "Send message"}
            </button>
          </form>
        )}
      </div>
    </MarketingLayout>
  );
}
